import { css } from "@emotion/react";
import styled from "@emotion/styled";
import {
	CheckBox as CheckBoxFromUi,
	CheckBoxProps,
	StyledCheckBox,
} from "@animech/ui";
import { FunctionComponent } from "react";

export type CheckBoxPropagateColorProps = CheckBoxProps<boolean>;
const CheckBoxWithProps: FunctionComponent<CheckBoxPropagateColorProps> = (
	props,
) => <CheckBoxFromUi {...props} />;

export const CheckBox = styled(CheckBoxWithProps)`
	${({ theme }) => {
		return css`
			display: flex;
			justify-content: center;
			align-items: center;

			/* Customize checkbox to look like a toggle switch */
			${StyledCheckBox.CheckedIcon} {
				position: relative;
				border-radius: 10px;
				flex-basis: 40px;
				transition: background-color 0.2s ease-out;
				background-color: #999;

				::before,
				::after {
					border-radius: 10px;
					box-shadow: none !important;
				}

				> svg {
					display: block;
					width: 12px;
					height: 12px;
					background-color: ${theme.colors.backgrounds[0].background};
					border-radius: 6px;
					position: absolute;
					transition:
						transform 0.2s ease-out,
						left 0.2s ease-out;

					> * {
						display: none;
					}
				}
			}

			&:not([data-checked="true"]) {
				${StyledCheckBox.CheckedIcon} {
					background-color: #999 !important;
					> svg {
						left: 4px;
					}
				}
			}

			&[data-checked="true"] {
				${StyledCheckBox.CheckedIcon} {
					background-color: #333 !important;
					> svg {
						left: calc(100% - 4px);
						transform: translateX(-100%);
					}
				}
			}
		`;
	}}
`;
